import React, { useEffect, useRef, useState } from 'react';
import CurrencyFormat from 'react-currency-format';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Formik, FormikProps, FormikValues } from 'formik';
import moment from 'moment';
import { KTSVG } from 'src/_metronic/helpers';
// import { useControlGib } from 'src/app/modules/accounts/service';
import Restricted from 'src/app/permissions/restricted';
import * as Yup from 'yup';
import { useBanksList, useCashesList, useFinanceCreate, usePaymentMethod, useRegistrationCertainList, useInstallmentList } from '../service';

type Props = {};

export default function Create({}: Props) {
  const onErrorFetch = (e: any) => e?.response?.data?.message && toast.error(e?.response?.data?.message);
  const formikRef = useRef<FormikProps<any> | any>(null);
  const onSuccessFetch = (e: any) => {
    toast.success(`Ödeme başarıyla oluşturuldu.`);
    formikRef?.current?.resetForm();
  };

  const [selectRegistrationID, setSelectRegistrationID] = useState();
  const [invoicePermission, setInvoicePermission] = useState(false);

  const { data: registrationList, isLoading: registartionIsLoading, isFetching: registrationIsFetching } = useRegistrationCertainList(onErrorFetch);
  const { data: methodList, isLoading: methodIsLoading, isFetching: methodIsFetching } = usePaymentMethod(onErrorFetch);
  const { data: banksList, isLoading: banksIsLoading, isFetching: banksIsFetching } = useBanksList(onErrorFetch);
  const { data: cashesList, isLoading: cashesIsLoading, isFetching: cashesIsFetching } = useCashesList(onErrorFetch);
  const {
    data: installmentList,
    isLoading: installmentIsLoading,
    isFetching: installmentIsFetching,
    refetch: installmentRefetch,
  } = useInstallmentList({ ...{ registration_id: selectRegistrationID } }, onErrorFetch);
  // const { data: gibControlData, isLoading: gibControlIsLoading, isFetching: gibControlIsFetching } = useControlGib(onErrorFetch);

  console.log('registrationList', registrationList);
  const { isLoading, mutate, reset } = useFinanceCreate(onSuccessFetch, onErrorFetch);

  const financeSchema = Yup.object().shape({
    registration_id: Yup.string().min(1, 'Öğrenci seçin.').required('Öğrenci seçin.'),
    payment_method_id: Yup.string().min(1, 'Ödeme yöntemi belirtin.').required('Ödeme yöntemi belirtin.'),
    payment_note: Yup.string().min(3, 'Ödeme notu belirtin.').required('Ödeme notu belirtin.'),
    transaction_date: Yup.date().max(moment().format('YYYY-MM-DD'), 'Bugünkü tarihten sonra bir tarih seçilemez.').required('Ödeme tarihini belirtin.'),
    price: Yup.object().shape({
      floatValue: Yup.string().min(1).required('Lütfen ödeme tutarını belirtin.'),
      formattedValue: Yup.string().min(1).required('Lütfen ödeme tutarını belirtin.'),
      value: Yup.number().min(1).required('Lütfen ödeme tutarını belirtin.'),
    }),
    expiration_date: Yup.date().when('payment_method_id', {
      is: '9',
      then: Yup.date().test('isExpirationValid', 'Lütfen vade tarihini belirtin.', function (value, { createError }) {
        if (!value) {
          return false;
        } else if (moment().diff(moment(value), 'days') > 0) {
          throw createError({
            message: 'Lütfen vade tarihini gelecek tarih olarak belirtin.',
          });
        }
        return true;
      }),
    }),
    bank_id: Yup.string()
      .nullable()
      .test('bank_id', 'Lütfen geçerli bir banka seçin.', (val: any, validationContext: any) => {
        const { createError, parent } = validationContext;
        if (methodList?.find((e: any) => Number(e.id) === Number(parent?.payment_method_id))?.is_bank) {
          if (val && val.length) return true;
          return createError({ message: 'Lütfen banka seçin.' });
        } else {
          return true;
        }
      }),
    cash_id: Yup.string()
      .nullable()
      .test('cash_id', 'Lütfen geçerli bir kasa seçin.', (val: any, validationContext: any) => {
        const { createError, parent } = validationContext;
        if (methodList?.find((e: any) => Number(e.id) === Number(parent?.payment_method_id))?.is_cash) {
          if (val && val.length) return true;
          return createError({ message: 'Lütfen kasa seçin.' });
        } else {
          return true;
        }
      }),
    selectedInstallments: Yup.array()
      .of(
        Yup.object().shape({
          installmentNo: Yup.string().required('Lütfen bu alanı doldurun.'),
          remainingAmount: Yup.number().positive("Lütfen 0'dan büyük değer belirtin.").required('Lütfen bu alanı doldurun.'),
        }),
      )
      .required('Lütfen bir taksit seçin veya alt kısımdaki farklı bir tutar seçeneğini aktif edin.'),
    differentPrice: Yup.bool(),
    // between_payment: Yup.string()
    //   .oneOf(['between', 'notBetween'])
    //   .when('differentPrice', {
    //     is: (e: boolean) => {
    //       console.log(e);
    //       return e;
    //     },
    //     then: Yup.string().required('Lütfen işlem türü seçiniz.'),
    //   }),
  });

  var initialValues = {
    registration_id: '',
    payment_method_id: '',
    transaction_date: '',
    payment_note: '',
    expiration_date: '',
    bank_id: null,
    cash_id: null,
    price: {
      formattedValue: '',
      value: '',
      floatValue: 0,
    },
    selectedInstallments: [],
    differentPrice: false,
    // between_payment: '',
  };

  // Tek kasa varsa otomatik seçim için useEffect ekle (initialValues tanımından sonra)
  useEffect(() => {
    if (cashesList?.length === 1 && formikRef.current) {
      formikRef.current.setFieldValue('cash_id', cashesList[0]?.unique_id);
    }
  }, [cashesList]);

  /*useEffect(() => {
    if (installmentList && installmentList?.length > 0) {
      const initInstallment = [installmentList?.filter((e: any) => !e.isPay)[0]];
      formikRef?.current?.setFieldValue('selectedInstallments', initInstallment);
      formikRef?.current?.setFieldValue('price', {
        value: initInstallment?.reduce((accumulator: any, ie: any) => {
          return accumulator + (ie?.remainingAmount || 0);
        }, 0),
        floatValue: initInstallment?.reduce((accumulator: any, ie: any) => {
          return accumulator + (ie?.remainingAmount || 0);
        }, 0),
        formattedValue: initInstallment?.reduce((accumulator: any, ie: any) => {
          return accumulator + (ie?.remainingAmount || 0);
        }, 0),
      });
    }
  }, [installmentList]);*/

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={financeSchema}
      onSubmit={(values, { setSubmitting }) => {
        const body: any = { ...values };
        body.price = body.price?.floatValue;
        body.invoicePermission = invoicePermission;
        // body.deduct_from_installment = body?.between_payment === 'between' ? true : false;
        body.deduct_from_installment = false;

        console.log('body', body);
        mutate(body);
        setSubmitting(false);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        getFieldProps,
        isSubmitting,
        isValid,
        /* and other goodies */
      }) => (
        <form onSubmit={handleSubmit}>
          <h3 className="mb-5">Ödeme Oluştur</h3>
          <div className="card">
            <div className="card-body w-100">
              <div className="row align-items-center justify-content-between mb-5">
                <div className="col-xl-12 mb-3">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-12 mb-3">
                      <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Müşteri Adı Soyadı:</label>
                      <Select
                        options={[{ id: '', name_lastname: '-' }].concat(registrationList?.results)?.map((e: any) => ({
                          value: e?.id,
                          label:
                            e?.name_lastname +
                            (e?.date_of_organisation ? ` - ${moment(e?.date_of_organisation).format('DD MMMM YYYY')}` : '') +
                            (e?.organisation_type?.name ? ` - ${e?.organisation_type?.name}` : '') +
                            (e?.areas?.name ? ` - ${e?.areas?.name}` : ''),
                        }))}
                        placeholder="Müşteri seçin"
                        noOptionsMessage={() => <div>Kişi bulunamadı</div>}
                        value={registrationList?.results
                          ?.map((e: any) => ({ value: e?.id, label: e?.name_lastname }))
                          .filter(function (option: any) {
                            return option.value === values?.registration_id;
                          })}
                        onChange={(e: any) => {
                          setFieldValue('registration_id', e.value);
                          setSelectRegistrationID(e.value);
                          setTimeout(() => {
                            installmentRefetch();
                          }, 100);
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: '#F5F8FA',
                            borderColor: errors.registration_id && touched.registration_id ? 'red' : 'transparent',
                            borderWidth: errors.registration_id && touched.registration_id ? 1 : 0,
                          }),
                        }}
                      />
                    </div>
                    {values?.registration_id && (
                      <div className="col-md-12 mb-3">
                        <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Ödeme Tablosu:</label>
                        <div className="table-responsive p-4 bg-secondary bg-opacity-25 rounded">
                          <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 border border-solid border-secondary bg-white ">
                            {/* begin::Table head */}
                            <thead>
                              <tr className="fw-bolder text-muted">
                                <th className="min-w-50px ps-2">Ödeme Sırası</th>
                                <th className="min-w-50px">Ödeme Tutarı</th>
                                <th className="min-w-50px">Ödeme Tarihi</th>
                                <th className="min-w-50px">Ödeme Şekli</th>
                                <th className="min-w-50px">Kalan Tutar</th>
                              </tr>
                            </thead>
                            {/* end::Table head */}
                            {/* begin::Table body */}
                            <tbody>
                              {installmentList?.length > 0 ? (
                                installmentList?.map((data: any, index: number) => (
                                  <tr>
                                    <td className="ps-2">{index + 1}. Ödeme</td>
                                    <td>{data?.price?.toLocaleString('tr-TR')} ₺</td>
                                    <td>{moment(data?.transaction_date).format('DD MMMM YYYY')}</td>
                                    <td>{data?.payment_method_name}</td>
                                    <td>{data?.price.toLocaleString('tr-TR')} ₺</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={5} className="text-center text-muted">
                                    Daha önce hiçbir ödeme gerçekleştirilmemiş.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                            {/* end::Table body */}
                          </table>
                        </div>
                      </div>
                    )}

                    {console.log('installmentList : ', installmentList)}
                    {console.log('errors : ', errors)}
                    <div className="col-md-6 mb-3">
                      <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Ödeme Yöntemi:</label>
                      <Select
                        options={[{ id: '', name: '-' }].concat(methodList)?.map((e: any) => ({ value: e?.id, label: e?.name }))}
                        placeholder="Ödeme yöntemi seçin"
                        value={methodList
                          ?.map((e: any) => ({ value: e?.id, label: e?.name }))
                          .filter(function (option: any) {
                            return option.value === values?.payment_method_id;
                          })}
                        onChange={(e: any) => {
                          setFieldValue('payment_method_id', e.value);
                          setFieldValue('cash_id', null);
                          setFieldValue('bank_id', null);
                        }}
                        noOptionsMessage={() => <div>Ödeme yöntemi bulunamadı</div>}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            backgroundColor: '#F5F8FA',
                            borderColor: errors.payment_method_id && touched.payment_method_id ? 'red' : 'transparent',
                            borderWidth: errors.payment_method_id && touched.payment_method_id ? 1 : 0,
                          }),
                        }}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Ödeme Tarihi:</label>
                      <input
                        type="date"
                        className={`form-control form-control-solid ${errors.transaction_date && touched.transaction_date && 'is-invalid border-danger'}`}
                        {...getFieldProps('transaction_date')}
                        max={moment().format('YYYY-MM-DD')}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-12 mb-3">
                  <div className="row align-items-center mb-3">
                    {/* <div className={values?.differentPrice ? 'col-md-6 mb-3' : 'col-md-12 mb-3'}> */}
                    <div className="col-md-12 mb-3">
                      <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Ödenen Tutar:</label>
                      <CurrencyFormat
                        suffix={'₺'}
                        decimalScale={2}
                        decimalSeparator={','}
                        thousandSeparator={'.'}
                        className={`form-control form-control-solid ${errors.price && touched.price && 'is-invalid border-danger'}`}
                        onValueChange={(e) => formikRef.current?.setFieldValue('price', e)}
                        onBlur={handleBlur}
                        name="price"
                        value={values?.price?.formattedValue}
                        // disabled={!values?.differentPrice}
                        allowNegative={false}
                      />
                    </div>
                    {/* {values?.differentPrice && (
                      <div className="col-md-6 mb-3">
                        <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">İşlem Türü:</label>
                        <div className="row align-items-end d-flex">
                          <div className="col-6 bg-gray">
                            <button
                              type="button"
                              onClick={() => setFieldValue('between_payment', 'between')}
                              className={`btn btn-sm btn-outline btn-outline-dashed ${
                                values?.between_payment === 'between' ? `btn-active-light-primary` : `btn-active-light-secondary`
                              } ${errors.between_payment && touched.between_payment && 'is-invalid border-danger'}  d-flex text-start px-4 py-3
                          ${values?.between_payment === 'between' && `active`} align-items-center`}
                              data-kt-button="true"
                            >
                              <KTSVG path="/media/icons/duotone/Shopping/Wallet2.svg" className="svg-icon-3 svg-icon" />
                              <span className="ms-5">
                                <span className="fs-7 fw-bold text-gray-800 d-block">Taksit Tutarından Düş</span>
                              </span>
                            </button>
                          </div>
                          <div className="col-6">
                            <button
                              type="button"
                              onClick={() => {
                                setFieldValue('between_payment', 'notBetween');
                              }}
                              className={`btn btn-sm  btn-outline btn-outline-dashed ${
                                values?.between_payment === 'notBetween' ? `btn-active-light-primary` : `btn-active-light-secondary`
                              } d-flex text-center px-4 py-3 align-items-center
                        ${values?.between_payment === 'notBetween' && `active`} ${errors.between_payment && touched.between_payment && 'is-invalid border-danger'}`}
                              data-kt-button="true"
                            >
                              <KTSVG path="/media/icons/duotone/Home/Timer.svg" className="svg-icon-3 svg-icon " />
                              <span className="ms-5">
                                <span className="fs-7 fw-bold text-gray-800 d-block">Taksit Sayısından Düş</span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    )} */}
                    {/* <div className="col-md-12 mb-1 d-flex align-items-center">
                      <label className="form-label fs-7 mb-0 mx-2 text-gray-600 fw-bold text-nowrap">Ödeme Tutarını Farklı Gir :</label>
                      <div className="form-check form-check-custom form-check-solid">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={values?.differentPrice}
                          onChange={(e: any) => {
                            const initInstallment = [installmentList?.filter((e: any) => !e.isPay)[0]];
                            setFieldValue('differentPrice', e?.target?.checked);
                            setFieldValue('selectedInstallments', e.target.checked ? [] : initInstallment);
                            setFieldValue(
                              'price',
                              e.target.checked
                                ? { value: 0, formattedValue: 0, floatValue: 0 }
                                : {
                                    value: initInstallment?.reduce((accumulator: any, ie: any) => {
                                      return accumulator + (ie?.remainingAmount || 0);
                                    }, 0),
                                    floatValue: initInstallment?.reduce((accumulator: any, ie: any) => {
                                      return accumulator + (ie?.remainingAmount || 0);
                                    }, 0),
                                    formattedValue: initInstallment?.reduce((accumulator: any, ie: any) => {
                                      return accumulator + (ie?.remainingAmount || 0);
                                    }, 0),
                                  },
                            );
                          }}
                          data-kt-check="true"
                          data-kt-check-target=".widget-13-check"
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
                {methodList?.find((e: any) => e.id === values.payment_method_id)?.is_bank && (
                  <div className="col-xl-12 mb-3">
                    <div className="row align-items-center mb-3">
                      <div className="col-md-12 mb-3">
                        <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Banka</label>
                        <select className={`form-select form-select-solid ${errors.bank_id && touched.bank_id && 'is-invalid border-danger'}`} {...getFieldProps('bank_id')}>
                          <option value={''}>Seçiniz</option>
                          {banksList?.map((bank: any, idx: number) => (
                            <option key={idx} value={bank?.unique_id}>
                              {bank?.unique_id} - {bank?.account_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {methodList?.find((e: any) => e.id === values.payment_method_id)?.is_cash && (
                  <div className="col-xl-12 mb-3">
                    <div className="row align-items-center mb-3">
                      <div className="col-md-12 mb-3">
                        <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Kasa</label>
                        <select className={`form-select form-select-solid ${errors.cash_id && touched.cash_id && 'is-invalid border-danger'}`} {...getFieldProps('cash_id')}>
                          <option value={''}>Seçiniz</option>
                          {cashesList?.map((cash: any, idx: number) => (
                            <option key={idx} value={cash?.unique_id}>
                              {cash?.unique_id} - {cash?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {Number(values?.payment_method_id) === 9 && (
                  <div className="col-xl-12 mb-3">
                    <div className="row align-items-center mb-3">
                      <div className="col-md-12 mb-3">
                        <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Vade Tarihi:</label>
                        <input
                          type="date"
                          className={`form-control form-control-solid ${errors.expiration_date && touched.expiration_date && 'is-invalid border-danger'}`}
                          {...getFieldProps('expiration_date')}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-xl-12 mb-3">
                  <label className="form-label fs-7 mb-0 text-gray-600 fw-bold text-nowrap">Not</label>
                  <textarea
                    name="payment_note"
                    rows={3}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.payment_note}
                    className={`form-control form-control-solid ${errors.payment_note && touched.payment_note && 'is-invalid border-danger'}`}
                  />
                </div>

                <div className="col-xl-12 mt-5 d-flex justify-content-end">
                  <Restricted to="ROLE_FINANCE_PAYMENT_CREATE">
                    <button type="submit" className="btn btn-light-success" disabled={isSubmitting}>
                      Oluştur
                      {isLoading && <span className="spinner-border spinner-border-sm align-middle mx-2 text-white"></span>}
                    </button>
                  </Restricted>
                </div>
              </div>
            </div>

            {/* <div className="card-footer d-flex justify-content-end">
              <div className="d-flex flex-column">
                <div className="d-flex form-check form-switch form-check-custom form-check-solid mb-3 mx-5">
                  <label className="form-label mx-2" style={{ marginBottom: 0 }}>
                    Otomatik e-Arşiv taslak fatura oluşturulsun.{' '}
                  </label>
                  <input
                    name="is_active"
                    disabled={gibControlData ? false : true}
                    className="form-check-input  h-25px w-40px"
                    type="checkbox"
                    id="flexSwitchDefault"
                    checked={invoicePermission}
                    onChange={() => {
                      setInvoicePermission(!invoicePermission);
                    }}
                  />
                </div>
                {!gibControlData && (
                  <span className="text-danger fw-bold fs-7 mx-7 mb-3">
                    (Doğrulanmış GIB bilgileriniz bulunmuyor.)
                    <Link to="/account/settings"> GIB Giriş ve Doğrulama</Link>
                  </span>
                )}
                <span className="text-muted fs-7 mx-7">Oluşturulan faturanızı imzalamak için G.İ.B. e-Arşiv kısmını ziyaret etmelisiniz.</span>
              </div>
              <Restricted to="ROLE_FINANCE_PAYMENT_CREATE">
                <button type="submit" className="btn btn-light-success" disabled={isSubmitting}>
                  Oluştur
                  {isLoading && <span className="spinner-border spinner-border-sm align-middle mx-2 text-white"></span>}
                </button>
              </Restricted>
            </div> */}
          </div>
        </form>
      )}
    </Formik>
  );
}
